import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { ProductStates } from '../../product-state-machine/product-state-machine-types';
import { ResultIcon } from './result-icon';
import { ResultAvatar } from '../../../common/result-avatar';
import { defaultResultRenderer } from '../../../extensible/search-result/default-result-renderer';

/**
 * This function renders a component search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 *
 * We override this to use different size icons for pre query and post query states
 */
export var componentResultRenderer = function componentResultRenderer(args) {
  var _searchResult$icon$to, _searchResult$icon;
  var productState = args.productState,
    searchResult = args.searchResult;
  var iconSize = productState === ProductStates.PreQuerySuccess ? 'small' : 'medium';
  var iconType = (_searchResult$icon$to = (_searchResult$icon = searchResult.icon) === null || _searchResult$icon === void 0 ? void 0 : _searchResult$icon.toString()) !== null && _searchResult$icon$to !== void 0 ? _searchResult$icon$to : '';
  return defaultResultRenderer(_objectSpread(_objectSpread({}, args), {}, {
    searchResult: _objectSpread(_objectSpread({}, searchResult), {}, {
      icon: /*#__PURE__*/React.createElement(ResultIcon, {
        type: iconType,
        size: iconSize
      })
    })
  }));
};

/**
 * This function renders a people or team search result using the default component offered
 * by the search platform. Specifically, the SearchResultContent is used.
 *
 * We override this to use different size icons for pre query and post query states
 */
export var peopleAndTeamsResultRenderer = function peopleAndTeamsResultRenderer(args) {
  var productState = args.productState,
    searchResult = args.searchResult;
  var iconSize = productState === ProductStates.PreQuerySuccess ? 'xsmall' : 'small';
  return defaultResultRenderer(_objectSpread(_objectSpread({}, args), {}, {
    searchResult: _objectSpread(_objectSpread({}, searchResult), {}, {
      icon: /*#__PURE__*/React.createElement(ResultAvatar, {
        borderColor: "transparent",
        src: searchResult.iconUrl,
        appearance: "square",
        size: iconSize,
        testId: "result-avatar"
      })
    })
  }));
};